import styled from 'styled-components';
import { exactWhite, green, lightBlue } from 'utils/style/colors';

interface IStatusProps {
  complete: boolean;
}

export const StatusInfo = styled.span`
  padding: 0px;
  font-size: 9px;
  margin-top: 0px;
  line-height: 13px;
  text-align: center;
  position: absolute;
  top: 30px;
  width: 3rem;
  // display: none;
`;
export const StatusContainer = styled('div')`
  // padding-top: 4px
  display: grid !important;
  position: relative;

  // :hover > ${StatusInfo} {
  //     display: initial
  // }
`;

export const Status = styled('span')<IStatusProps>`
  width: 1.7em;
  height: 1.7em;
  border: ${(props) => (props.complete ? 'none' : '1px solid #9e9e9e')};
  color: ${(props) => (props.complete ? 'var(--exact-white)' : '#9e9e9e')};
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.complete && green};
  cursor: pointer;
  &:hover {
    border: 1px solid ${green};
  }
`;

export const StatusPercent = styled('span')`
  font-size: 8px;
  font-weight: 500;
`;

export const InfoBadgeBlue = styled.div`
  color: ${exactWhite};
  background-color: ${lightBlue};
  border-radius: 0.5rem;
  padding: 0.5rem 0.25rem;
  margin: 0.5rem 0;
`;
